const checkObjectValue = obj => {
  return Object.values(obj).every(o => o !== null && o !== false && o !== "")
}

export default checkObjectValue
